import React from 'react';
import { goToBudgetHistory, goToCurrentBudget } from 'src/services/router.service';
import styles from './BudgetHeaderRow.module.scss';
import { useHistory } from 'react-router-dom';
import LiteralsService from 'src/services/literals/LiteralsService';
import { BudgetPages } from 'src/components/atomic/pages/BudgetPages';
import { trackClick } from 'src/hooks/useAdobeTags';
import adobeTags from 'src/types/adobe-tags';
import useCurrentUser from 'src/hooks/useCurrentUser';

interface Props {
    currentPage?: BudgetPages;
}

export default function BudgetHeaderRow({ currentPage }: Props): JSX.Element {
    const history = useHistory();
    const { isFullPlanUser } = useCurrentUser();

    let current;
    switch (currentPage) {
        case BudgetPages.HOME:
            current = LiteralsService.getLiteral('Budget.currentMonth');
            break;
        case BudgetPages.HISTORY:
            current = LiteralsService.getLiteral('TertiaryNavigation.history');
            break;
        default:
            break;
    }

    return (
        <nav
            className={`nav nav-horizontal border nav-chevron ${styles.tertiaryNav}`}
            data-toggle="nav"
            data-responsive="md"
            aria-label={LiteralsService.getLiteral('TertiaryNavigation.tertiaryNav')}
        >
            <ul className="nav-menu">
                <li className="nav-item">
                    <button
                        className="nav-link caret"
                        aria-current={current === LiteralsService.getLiteral('Budget.currentMonth') ? 'page' : 'false'}
                        onClick={() => {
                            trackClick(history.location.pathname, adobeTags.TertiaryNav.Current);
                            goToCurrentBudget(isFullPlanUser, history);
                        }}
                    >
                        {LiteralsService.getLiteral('Budget.currentMonth')}
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className="nav-link caret"
                        aria-current={
                            current === LiteralsService.getLiteral('TertiaryNavigation.history') ? 'page' : 'false'
                        }
                        onClick={() => {
                            trackClick(history.location.pathname, adobeTags.TertiaryNav.History);
                            goToBudgetHistory(isFullPlanUser, history);
                        }}
                    >
                        {LiteralsService.getLiteral('TertiaryNavigation.history')}
                    </button>
                </li>
            </ul>
        </nav>
    );
}
